export type BadgeTone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral' | 'accent' | 'purple';

/**
 * Shared status → tone mapping so a given status reads identically on every
 * screen: "Delivered" is always green, "Cancelled" always red.
 *
 * Kept out of the components file so Fast Refresh can still hot-swap those
 * components (a module must export only components for that to work).
 */
export function statusTone(status: string): BadgeTone {
  const value = status.toUpperCase();

  if (['DELIVERED', 'COMPLETED', 'PAID', 'VERIFIED', 'ACTIVE', 'WON', 'ACCEPTED'].includes(value)) {
    return 'success';
  }
  if (
    ['PENDING', 'PENDING_PAYMENT', 'UNDER_REVIEW', 'VERIFICATION_PENDING', 'NEGOTIATION', 'DRAFT'].includes(
      value,
    )
  ) {
    return 'warning';
  }
  if (['CANCELLED', 'REJECTED', 'FAILED', 'BLOCKED', 'LOST', 'EXPIRED', 'NOT_PAID'].includes(value)) {
    return 'danger';
  }
  if (['SHIPPED', 'IN_TRANSIT', 'SENT', 'VIEWED', 'CONTACTED', 'REFUNDED'].includes(value)) {
    return 'brand';
  }
  if (['PROCESSING', 'PACKED', 'READY_TO_SHIP', 'QUALIFIED'].includes(value)) {
    return 'purple';
  }
  return 'neutral';
}

/** "PENDING_PAYMENT" → "Pending Payment" */
export function humanize(value: string): string {
  return value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
